<div>
  <app-basic-field-number-r #read *ngIf="RorE" [RealValue]="RealValue" [Title]="Title"
    [MaxNumsAfterDot]="MaxNumsAfterDot" [FrontDecor]="FrontDecor" [RearDecor]="RearDecor" [Comment]="Comment">
  </app-basic-field-number-r>
  <app-basic-field-number-w #write *ngIf="!RorE" [RealValue]="RealValue" [Title]="Title"
    [MaxNumsAfterDot]="MaxNumsAfterDot" [FrontDecor]="FrontDecor" [RearDecor]="RearDecor" [Comment]="Comment"
    [ShowRealVal]=true [MaxVal]="MaxVal" [MinVal]="MinVal"></app-basic-field-number-w>
  <button
    [ngClass]="RorE ? (Comment == '' ? 'small-button-read' : 'small-button-read-units') : (Comment == '' ? 'small-button-edit' : 'small-button-edit-units')"
    mat-stroked-button (click)="SwitchRorE()"
    [matTooltip]="RorE ? ('ARO.SWITCH_TO_EDIT' | translate) : ('ARO.SWITCH_TO_VIEW' | translate)">
    <mat-icon class="svg-icon">{{RorE ? "edit" : "settings_backup_restore"}}</mat-icon>
  </button>
</div>